function CtaSection() {
  return (
    <section className="ac-cta ac-width">
      <h2>Když ti to sedí,<br />přidej se.</h2>
      <div>
        <p>Jsme na Discordu.</p>
        <a href="https://discord.allcom.zone" className="ac-button" target="_blank" rel="noopener noreferrer">
          Vstoupit na Discord
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6" /></svg>
        </a>
      </div>
    </section>
  )
}

export default CtaSection
